var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcLocation38X38 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 38,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.252 9.326c4.644-5.339 12.89-5.339 17.522 0h-.013c4.026 4.644 3.473 11.72-.875 16.068l-6.857 6.857a1.444 1.444 0 0 1-2.045 0l-6.857-6.857c-4.348-4.348-4.901-11.424-.875-16.068Zm12.62 7.577a3.86 3.86 0 1 1-7.718 0 3.86 3.86 0 0 1 7.718 0Z",
  fill: "#2D91FF"
})));
export default SvgIcLocation38X38;